export enum AttachmentValidationStatus {
  waiting = 'waiting',
  validated = 'validated',
  rejected = 'rejected',
}
